import router from './router'
import store from '/@/store'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types'
import { RouteRecordRaw } from 'vue-router'
import { loginByToken } from '/@/api/manage'
import { loginSuccess } from '/@/websocket/util/config'

const whiteList = ['/project', '/freeLogin', '/pilot-login']
const dynamicRouteNames = new Set<string>()

function collectRouteNames (route: RouteRecordRaw) {
  if (route.name) {
    dynamicRouteNames.add(String(route.name))
  }
  route.children?.forEach(child => collectRouteNames(child))
}

function removeDynamicRoutes () {
  Array.from(dynamicRouteNames).reverse().forEach(name => {
    if (router.hasRoute(name)) {
      router.removeRoute(name)
    }
  })
  dynamicRouteNames.clear()
}

function addDynamicRoutes (routes: RouteRecordRaw[]) {
  routes.forEach(route => {
    router.addRoute(route)
    collectRouteNames(route)
  })
}

async function rebuildDynamicRoutes () {
  removeDynamicRoutes()
  const accessRoutes = await store.dispatch('GenerateRoutes') as RouteRecordRaw[]
  addDynamicRoutes(accessRoutes)
}

router.beforeEach(async (to, from, next) => {
  if (localStorage.getItem(ELocalStorageKey.Token)) {
    const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
    switch (flag) {
      case EUserType.Web:
        if (to.path === '/project' || to.path === '/') {
          next()
        } else {
          const hasGeneratedRoutes = store.state.sidebarRouters.length > 0
          const hasMatchedRoute = to.matched.length > 0
          if (hasGeneratedRoutes && hasMatchedRoute) {
            next()
          } else {
            try {
              await rebuildDynamicRoutes()
              if (router.resolve(to.fullPath).matched.length > 0) {
                next({ ...to, replace: true })
              } else {
                next('/404')
              }
            } catch (err) {
              console.error('动态路由加载失败:', err)
              next('/404')
            }
          }
        }
        break
      case EUserType.Pilot:
        next()
        break
      default:
        next()
        break
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else if (to.path.startsWith('/large_screen')) {
      const urlToken = to.query.token
      // 有 token → 尝试免登录
      if (urlToken) {
        try {
          const res = await loginByToken(<loginByToken>{ token: urlToken })
          if (res.code === 0) {
            loginSuccess(res)
            // 登录成功后去掉 token 参数（防止泄露）
            next({ path: to.path, query: {} })
            return
          }
        } catch (err) {
          console.error('Token 登录失败', err)
          next('/project')
        }
      } else {
        next('/project')
      }
    } else if (to.path.startsWith('/manage_device')) {
      const urlToken = to.query.token
      // 有 token → 尝试免登录
      if (urlToken) {
        try {
          const res = await loginByToken(<loginByToken>{ token: urlToken })
          if (res.code === 0) {
            loginSuccess(res)
            // 登录成功后去掉 token 参数（防止泄露）
            next({ path: to.path, query: { id: to.query.id, deviceSn: to.query.deviceSn } })
            return
          }
        } catch (err) {
          console.error('Token 登录失败', err)
          next('/project')
        }
      } else {
        next('/project')
      }
    } else {
      next('/project') // 否则全部重定向到登录页
    }
    // next()
  }
})
